import Box from '@mui/material/Box';
import logo from 'assets/logos/logo';
import deferRender from 'defer-render-hoc';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';
import Auth from 'services/api/Auth';
import authUser from 'store/selectors/authUser';
import { Translate } from 'utils/i18n';
import HttpStatus from 'http-status-codes';

const AcceptInviteScene = () => {
  const params = useParams();

  const user = useSelector(authUser);

  const [error, setError] = useState(null);
  const [errorStatus, setErrorStatus] = useState(null);

  useEffect(() => {
    const doAcceptInvite = async () => {
      if (user?.phone && params?.token) {
        try {
          await Auth.acceptInvite(user.phone, params.token);
          window.location.replace('/');
        } catch (e) {
          const errorMessage = e.response?.data?.data?.error || null;
          const status = e.response?.status || null;
          setError(errorMessage);
          setErrorStatus(status);
        }
      }
    };
    doAcceptInvite();
  }, [params.token, user?.phone]);

  if (error || errorStatus) {
    const isBlocked = errorStatus === HttpStatus.CONFLICT;
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          width: '100%',
          maxWidth: 375,
          margin: '0 auto',
          height: '100%',
          padding: '20px 20px',
        }}
      >
        <div>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              mb: '67px',
              color: 'primary.main',
            }}
          >
            <Box
              component="img"
              src={logo}
              alt="Ommnio"
              sx={{
                display: 'block',
                height: 52,
                filter: theme =>
                  theme.palette.mode === 'dark' ? 'invert(1) hue-rotate(180deg)' : 'invert(0)',
              }}
            />
          </Box>
          <Box
            component="h3"
            sx={{
              fontSize: 28,
              fontWeight: 'bold',
              color: 'error.main',
              letterSpacing: -0.7,
              mt: 0,
              mb: '21px',
              textAlign: 'center',
            }}
          >
            <Translate
              value={
                isBlocked
                  ? 'AcceptInviteScene.Phone number already used'
                  : 'AcceptInviteScene.Invalid invitation'
              }
            />
          </Box>
          <Box
            component="p"
            sx={{
              fontSize: 16,
              color: 'text.secondary',
              textAlign: 'center',
              mb: '24px',
            }}
          >
            <Translate
              value={
                isBlocked
                  ? 'AcceptInviteScene.Phone number already used description'
                  : 'AcceptInviteScene.Invalid invitation description'
              }
            />
          </Box>
          <Box
            component="a"
            href="/"
            sx={{
              color: 'primary.main',
              textDecoration: 'underline',
              cursor: 'pointer',
              textAlign: 'center',
              display: 'block',
            }}
          >
            <Translate value="AcceptInviteScene.Go to home" />
          </Box>
        </div>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        width: '100%',
        maxWidth: 375,
        margin: '0 auto',
        height: '100%',
        padding: '20px 20px',
      }}
    >
      <div>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mb: '67px',
            color: 'primary.main',
          }}
        >
          <Box
            component="img"
            src={logo}
            alt="Ommnio"
            sx={{
              display: 'block',
              height: 52,
              filter: theme =>
                theme.palette.mode === 'dark' ? 'invert(1) hue-rotate(180deg)' : 'invert(0)',
            }}
          />
        </Box>
        <Box
          component="h3"
          sx={{
            fontSize: 28,
            fontWeight: 'bold',
            color: 'primary.ultraDark',
            letterSpacing: -0.7,
            mt: 0,
            mb: '21px',
            textAlign: 'center',
          }}
        >
          <Translate value="AcceptInviteScene.Accepting invitation" />
        </Box>
      </div>
    </Box>
  );
};

export default deferRender(AcceptInviteScene);
